import { colors, headerHeight, mobileSize, tabletSize, zIndex } from "/constants"
import styled from "styled-components"

export const Root = styled.div`
  ${headerHeight.desktop};
  display: flex;
  align-items: center;
  transition: height 0.3s ease-in;
  @media (max-width: ${tabletSize}) {
    ${headerHeight.tablet};
  }
  @media (max-width: ${mobileSize}) {
    ${headerHeight.mobile};
  }
`

export const FixedWrapepr = styled.div`
  position: fixed;
  ${headerHeight.desktop};
  background-color: ${colors.white};
  top: 0;
  left: 0;
  right: 0;
  ${zIndex.header};
  transition: height 0.3s ease-in;
  @media (max-width: ${tabletSize}) {
    ${headerHeight.tablet};
  }
  @media (max-width: ${mobileSize}) {
    ${headerHeight.mobile};
  }
`

export const Container = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  margin: auto;
  max-width: 1140px;
  width: 100%;
  background-color: ${colors.white};
  padding: 0 20px;
  box-sizing: border-box;
  justify-content: space-between;
`

export const LangContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const LangLabel = styled.span`
  cursor: pointer;
  color: ${colors.brown_grey};
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`

export const TDCLogoAContainer = styled.a`
  height: 50px;
  @media (max-width: ${tabletSize}) {
    height: 40px;
  }
`

export const BottomLine = styled.div`
  height: 3px;
  background-color: ${colors.white};
  border-bottom: 3px solid ${colors.very_light_pink_four};
  @media (max-width: ${mobileSize}) {
    height: 0;
    border: none;
  }
`
